import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Hero from './Hero';
import LakersOT from './LakersOT';
import Contact from './Contact';
import Yaamava from './pages/Yaamava';
import TacoBell from './pages/TacoBell';
import PokerCards from './pages/DarkMode'
import AccessibleGalapagos from './pages/AccessibleGalapagos';
import GypsyPage from './GypsyPage';
import Qualifications from './Qualifications';
import NotFound from './pages/404Page'; 

import TagManager from 'react-gtm-module';

// Initialize GTM
const tagManagerArgs = {
  gtmId: 'GTM-TS3GG8TQ',
};
TagManager.initialize(tagManagerArgs);

// Custom hook for GTM route tracking
const useGTMRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: location.pathname,
      },
    });
  }, [location]);
};

// Wrapper component that lives inside <Router>
function GTMRouteTracker() {
  useGTMRouteTracking();
  return null; // it doesn’t render anything
}

function App() {
  return (
    <Router> {/* No need for basename with HashRouter */}
      {/* Place inside Router so useLocation works */}
      <GTMRouteTracker />
    
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/Qualifications" element={<Qualifications />} />
        <Route path="/GypsyPage" element={<GypsyPage />} />
        <Route path="/accessible-galapagos" element={<AccessibleGalapagos />} />
        <Route path="/poker" element={<PokerCards />} />
        <Route path="/tacobell" element={<TacoBell />} />
        <Route path="/yaamava" element={<Yaamava />} />
        <Route path="/lakersot" element={<LakersOT />} />
        <Route path="/contact" element={<Contact />} />
        {/* Catch-all route for 404 page */}
        <Route path="*" element={<NotFound />} />  
      </Routes>
    </Router>
  );
}

export default App;
